
import create from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";

import createPoliciesSlice from "./slices/createPoliciesSlice";
import createAccountManagementSlice from "./slices/createAccountManagementSlice";
import createAppSlice from "./slices/createAppSlice";
import createBranchDeployerSlice from "./slices/createBranchDeployerSlice";
import createCollectionsSlice from "./slices/createCollectionsSlice";
import createExploreAutoSaveSlice from "./slices/createExploreAutoSaveSlice";
import createConversationsSlice from "./slices/createConversationsSlice";
import createPreviewSlice from "./slices/createPreviewSlice";
import createTripletsSlice from "./slices/createTripletsSlice";
import createCampaignSlice from "./slices/createCampaignSlice";
import createNotificationsSlice from "./slices/createNotificationsSlice";
import createSpeechPlayerSlice from "./slices/createSpeechPlayerSlice";
import createConfigEditorSlice from "./slices/createConfigEditorSlice";

const devtoolsEnabled
  = import.meta.env.VITE_ENV && import.meta.env.VITE_ENV !== "production";
const useAppStore = create(
  devtools(
    subscribeWithSelector((...args) => ({
      ...createAppSlice(...args),
      ...createPreviewSlice(...args),
      ...createTripletsSlice(...args),
      ...createConversationsSlice(...args),
      ...createCollectionsSlice(...args),
      ...createExploreAutoSaveSlice(...args),
      ...createAccountManagementSlice(...args),
      ...createBranchDeployerSlice(...args),
      ...createCampaignSlice(...args),
      ...createNotificationsSlice(...args),
      ...createPoliciesSlice(...args),
      ...createSpeechPlayerSlice(...args),
      ...createConfigEditorSlice(...args)
    })),
    { name: "appStore", enabled: devtoolsEnabled }
  )
);
export default useAppStore;
